window.send_request = (method, url, data) => {
    const csrf_token = $('meta[name="csrf-token"]').attr('content');

    return new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();
        xhr.open(method, url);
        xhr.responseType = "json";
        xhr.setRequestHeader("X-CSRF-TOKEN", csrf_token);
        xhr.setRequestHeader('Content-Type','application/json')
        xhr.send(JSON.stringify(data));

        xhr.onload = () => {
            if(xhr.status >= 400){
                reject(xhr.response)
            }else{
                resolve(xhr.response);
            }
        }

        xhr.onerror = () => {
            reject('Something Error Happened !')
        }
    });
}